import React from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../../common/Routing/Routes';
import { DONATION_JAR_URL } from '../AboutPage/AboutPage';
import '../AboutPage/AboutPage.css';
import './FaqPage.css';

const READERLY_INSTAGRAM_URL = 'https://www.instagram.com/readerly_com/';

type FaqEntry = { question: string; answer: React.ReactNode };

const FAQ: FaqEntry[] = [
  {
    question: 'Скільки коштує оренда?',
    answer: (
      <p>
        Ціна вказана на сторінці кожної книжки — це донат за одну оренду, від 100 грн. Платите
        один раз за оренду, а не щомісяця. До цього додається лише доставка до вас.
      </p>
    ),
  },
  {
    question: 'Куди йдуть гроші?',
    answer: (
      <p>
        Усі гроші з оренди йдуть на деталі для FPV-дронів, які Катя і Валера в рамках проєкту
        Social Drone збирають своїми руками для ЗСУ. Донати надходять на{' '}
        <a href={DONATION_JAR_URL} target="_blank" rel="noopener noreferrer">
          банку Readerly
        </a>
        , а наприкінці кожного місяця ми переказуємо всю суму Каті й Валері. Детальніше — на
        сторінці <Link to={ROUTES.ABOUT}>Про нас</Link>.
      </p>
    ),
  },
  {
    question: 'Коли і як оплачувати?',
    answer: (
      <p>
        Після оформлення оренди ми зв’яжемося з вами і надішлемо лінк на банку для донату. Книжку
        відправляємо після того, як отримаємо донат.
      </p>
    ),
  },
  {
    question: 'Скільки коштує доставка?',
    answer: (
      <p>
        Доставку до вас оплачуєте ви за тарифами Укрпошти або Нової пошти — для однієї книжки це
        зазвичай вартість невеликої посилки. По Івано-Франківську є окрема доставка.
      </p>
    ),
  },
  {
    question: 'Скільки часу можна читати?',
    answer: (
      <p>
        Жорсткого терміну немає — читайте у своєму темпі, доплачувати за довше читання не
        потрібно. Якщо на книжку вже стоїть черга, ми можемо написати й запитати, коли плануєте
        повертати.
      </p>
    ),
  },
  {
    question: 'Як повернути книжку?',
    answer: (
      <p>
        Коли дочитаєте, напишіть нам — надішлемо дані для відправки. Зворотну
        доставку оплачуємо ми. Щоб вона коштувала менше, будь ласка, зберігайте пакування, у якому
        прийшла книжка, і використайте його ж для повернення.
      </p>
    ),
  },
  {
    question: 'Книжка зайнята. Що робити?',
    answer: (
      <p>
        Натисніть «Повідомте мене» на сторінці книжки — ви станете в чергу, і ми напишемо, щойно
        вона повернеться на полицю.
      </p>
    ),
  },
  {
    question: 'Що буде, якщо книжку пошкоджено або загублено?',
    answer: (
      <p>
        Буває. Просто напишіть нам — домовимося індивідуально. Звичайні сліди читання — це
        нормально, саме тому в нас видно історію кожного примірника.
      </p>
    ),
  },
];

function FaqPage() {
  return (
    <div className="about default-container">
      <section className="about-panel">
        <h1>Як це працює</h1>
        <p>
          Readerly — це оренда книжок за донат. Обираєте книжку, отримуєте її поштою, читаєте
          і повертаєте. Усі гроші з оренди йдуть на дрони для ЗСУ.
        </p>
      </section>

      <section className="about-panel faq-list">
        {FAQ.map((entry) => (
          <details key={entry.question} className="faq-item">
            <summary>{entry.question}</summary>
            {entry.answer}
          </details>
        ))}
      </section>

      <section className="about-panel">
        <h2>Не знайшли відповідь?</h2>
        <p>
          Пишіть нам в Instagram{' '}
          <a href={READERLY_INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
            @readerly_com
          </a>
          .
        </p>
      </section>
    </div>
  );
}

export default FaqPage;
